module.exports = __webpack_public_path__ + "static/img/mban.be4c13d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/mban.jpg
// module id = zjH+
// module chunks = 2